export default __webpack_public_path__ + "static/media/rad.6b804eb4.png";